import { render, staticRenderFns } from "./MedicinesDosage.vue?vue&type=template&id=d4f98fd2&scoped=true&"
import script from "./MedicinesDosage.vue?vue&type=script&lang=js&"
export * from "./MedicinesDosage.vue?vue&type=script&lang=js&"
import style0 from "./MedicinesDosage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MedicinesDosage.vue?vue&type=style&index=1&id=d4f98fd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f98fd2",
  null
  
)

export default component.exports